import { render, staticRenderFns } from "./CreateSong.vue?vue&type=template&id=f15ed2fe&"
import script from "./CreateSong.vue?vue&type=script&lang=js&"
export * from "./CreateSong.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CreateSong.vue"
export default component.exports